import Path from "@app/enum/Path";
import RouteSubPath from "@app/enum/RouteSubPath";

// The route-details pages, which hold their own pin legend selection. Shared with the router so
// the route patterns and the pages matched against them cannot drift apart.
const ROUTE_DETAILS_PATHS = {
  create: `${Path.ROUTE}/${RouteSubPath.CREATE}`,
  edit: `${Path.ROUTE}/${RouteSubPath.EDIT}/:routeId(\\d+)`,
  view: `${Path.ROUTE}/${RouteSubPath.VIEW}/:routeId(\\d+)`,
};

export default ROUTE_DETAILS_PATHS;
